import { Table } from "antd";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import BannerCard from "../../common/components/BannerCard";
import CleanButton from "../../common/components/CleanButton";
import Page from "../../common/components/Page";
import PDFModal from "../../common/components/PDFModal";
import useCivilLookup from "./useCivilLookup";

interface StateType {
  state: {
    returnData?: any;
    condition?: string;
    search?: string;
    returnStatus?: boolean;
  };
  key: string;
  pathname: string;
  search: string;
  hash: string;
}

const CivilLookup = () => {
  const {
    setCondition,
    setSearch,
    handleSearch,
    columns,
    data,
    condition,
    search,
    loading,
    fixedColumns,
    fixedData,
    handleNewQuery,
    returnStatus,
    setData,
    setReturnStatus,
    handleViewPDF,
    visibility,
    setVisibility
  } = useCivilLookup();
  const location = useLocation();

  useEffect(() => {
    const stateObject: StateType = { ...location };
    if (stateObject.state && stateObject.state.returnData) {
      setData(stateObject.state.returnData);
      setCondition(stateObject.state.condition);
      setSearch(stateObject.state.search);
      setReturnStatus(stateObject.state.returnStatus);
    } else {
      setData(null);
      setCondition("PLAINTIFF");
      setSearch(null);
      setReturnStatus(false);
    }
  }, [location, setCondition, setData, setReturnStatus, setSearch]);

  return (
    <Page>
      <Page.Title title="Civil Lookup" icon="search" />
      <Page.Controls
        onCivilScreen={true}
        onConditionChange={setCondition}
        conditionValue={condition}
        conditionSearch={search}
        onSearchChange={(e) => setSearch(e.target.value)}
        onSearch={handleSearch}
        isReturn={returnStatus}
        onNewSearch={handleNewQuery}
        loading={loading}
      ></Page.Controls>
      <Page.Content>
        {data && data.length ? (
          <>
            <CleanButton onClick={handleViewPDF} icon="eye" loading={visibility}>
              View PDF
            </CleanButton>
            <Table columns={columns} dataSource={data} loading={visibility ? visibility : loading} scroll={{ x: 720 }} />
            <PDFModal visibility={visibility} setVisibility={setVisibility} data={data} fromScreen="CL" />
          </>
        ) : (
          <BannerCard title="Description of lookup option(s)">
            <Table size="small" columns={fixedColumns} dataSource={fixedData} pagination={false} />
          </BannerCard>
        )}
      </Page.Content>
    </Page>
  );
};

export default CivilLookup;
